module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheada1-a2aef78853f539d43c8751ce44e3baad.jpg";